define('app-Accordions/main',['./settings', '../app/utilities/urlKey', 'underscore', "blazy", "util"], function (settings, UrlKey, _, Blazy, util) {
    return {
        run: function () {
            var self = this;
            self.settings = settings;
            self.urlKey = new UrlKey();

            if ($(settings.tabs).length === 0) {
                window.log('No ACCORDION CONTAINERS located. ACCORDIONS will not be available');
                return;
            }

            window.log('Loading ACCORDIONS app.');
            window.loadedModules('Accordions');

            var activeTab = self.urlKey.Get(settings.activeTabUrlKey);

            if (!activeTab) {
                $('#' + activeTab).show().removeAttr('aria-hidden');
                $('#' + activeTab).parent('.accordion-group').addClass('active');
            }


            $(settings.tabs + ' ' + settings.tabLink).click(function (e) {
                e.preventDefault();
                AdlAddUpdateItem("accordionToggleTitle", e.target.innerText.trim());

                var associatedTab;
                var targetDivId = '#' + $(e.target).attr('rel');
                var targetContent = $(e.target).data("target");

                if (targetContent) {
                    associatedTab = $(targetDivId + "[data-target='" + targetContent + "']");
                } else {
                    associatedTab = $(targetDivId);
                };

                var parent = associatedTab.parent('.accordion-group');

                if (associatedTab.is(':visible')) {
                    AdlAddUpdateItem("accordionToggleAction", "accordion-close");
                    associatedTab.slideUp('1000');
                    associatedTab.attr('aria-hidden', 'aria-hidden');
                    parent.removeClass('active');
                } else {
                    

                    $(associatedTab).slideDown('1000', function () {
                        AdlAddUpdateItem("accordionToggleAction", "accordion-open");
                        associatedTab.removeAttr('aria-hidden');
                        self.urlKey.Set(settings.activeTabUrlKey, $(e.target).attr('rel'));
                        parent.addClass('active');

                        if ($(associatedTab, ".app-GalleryWidget").is(':visible')) {
                            $(associatedTab).find('.app-GalleryWidget').each(function (index, element) {
                                var maxHeight = -1;
                                $(this).find('.widgetInner').each(function (index, element) {
                                    maxHeight = maxHeight > $(element).height() ? maxHeight : $(element).height();
                                });

                                $(this).find('.widgetInner').height(maxHeight);
                            });
                        }

                        var bLazy = new Blazy({
                            offset: 100, // Loads images 100px before they're visible
                            selector: ('.b-lazy, .b-lazy-div')
                        });
                    });
                }

                util.satelliteTrack('accordion interaction');
            });

            var tabColour = 0;
            _.each($(settings.tabs + ' ' + settings.tabLink), function (tl) {
                $(tl).parents(".accordion-heading");
                tabColour++;
                if (tabColour === settings.tabColours.length) tabColour = 0;
            });

            // temperary code fix. Needs to look into later.
            var associatedTab = $('#KeyInformation');
            var parent = associatedTab.parents('.accordion-group');
            associatedTab.slideDown(50);
            associatedTab.removeAttr('aria-hidden');
            parent.addClass('active');

            //Link to Sea tab on cruise
            $('.linkToAtSea').click(function (e) {
                e.preventDefault();
                if ($("#atSeaCarousel").length > 0) {
                    var targetOffset = $('#atSeaCarousel').offset().top;
                    $('html, body').animate({ scrollTop: targetOffset }, 1000);
                };
            });
        }
    }
});
